import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import eventBus from './common/Event';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(eventBus);

Vue.use(VueFilterDateFormat, {
  // dayOfWeekNames: [
  //   'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
  //   'Friday', 'Saturday'
  // ],
  // dayOfWeekNamesShort: [
  //   'Su', 'Mo', 'Tu', 'We', 'Tr', 'Fr', 'Sa'
  // ],
  // monthNames: [
  //   'January', 'February', 'March', 'April', 'May', 'June',
  //   'July', 'August', 'September', 'October', 'November', 'December'
  // ],
  // monthNamesShort: [
  //   'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  //   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  // ],
  timezone: 0
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
